import Head from 'next/head';

import { TermsConditionsSEO } from '@/utils/constants/MetaData';

const TermsandConditions = () => {
  return (
    <>
      <Head>
        <title>{TermsConditionsSEO.metaTitle}</title>
        <meta name="description" content={TermsConditionsSEO.metaDescription} />
        <meta
          property="og:description"
          content={TermsConditionsSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://www.muthootfincorpone.com/terms-and-conditions/"
        />
      </Head>
      <main className="home privacy-page">
        <section className="home__faq with-padding">
          <div className="container">
            <h1 className="section__title text--black text--bold">
              Terms & Conditions
            </h1>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_1"
              >
                <h2
                  className="text--black text--semi mt-1"
                  // style={{
                  //   fontWeight: '500',
                  // }}
                >
                  General Terms & Conditions
                </h2>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_1">
                <p>
                  This is a legal agreement between Muthoot Fincorp Limited, a
                  Company incorporated under the Companies Act, 1956 having its
                  registered office at Muthoot Centre, TC No 27/ 3022, Punnen
                  Road, Trivandrum - 695001, India (hereinafter referred to as
                  “MFL”, “Company”, “We”, “Our” or “Us”) and You (hereinafter
                  referred to as “You”, “Your”, “Yourself” or “User”)
                </p>
                <p>
                  The Company owns and operate mobile/web application by the
                  name “Muthoot FinCorp ONE” (“App”) and website at
                  muthootfincorpone.com (“Website”) (App and Website are
                  hereinafter together referred to as the “Platform”) .
                </p>
                <p>
                  These Terms and Conditions constitute a binding and
                  enforceable legal contract between the Company and the User of
                  the platform.
                </p>
                <p>
                  By accessing or using this platform, you agree to be bound by
                  these Terms and Conditions and Privacy Policy. By visiting the
                  platform or accessing the website to avail our services, you
                  accept and agree to abide by all the obligations stipulated in
                  these terms and conditions including the user hereby
                  irrevocably accepting the eSwarna digital Gold as gift.
                </p>
                <p>
                  Muthoot FinCorp ONE is a digital platform facilitating lending
                  and non-lending transactions between user and the Company and
                  other lending partners which are registered with The Reserve
                  Bank of India. The Company and other lending/non-lending
                  partners offer various products/services through the Muthoot
                  FinCorp ONE platform. All loan applications are approved and
                  sanctioned by the Company or the lending partner and are
                  communicated upfront during the Loan application stage. All
                  users shall abide by these terms and conditions.
                </p>

                <p>To these terms and conditions, the following shall mean:</p>
                <p>
                  1 .Personal Information- Personal Information means any
                  information that relates to a natural person, which, either
                  directly or indirectly, in combination with other information
                  available or likely to be available with a body corporate, is
                  capable of identifying such person.
                </p>
                <p>
                  {' '}
                  2. Privacy Policy- Shall mean the policy of the Company as
                  available on companies’ website and on the platform.
                </p>
                <p>
                  {' '}
                  3. Services- shall mean all the services provided by Muthoot
                  FinCorp ONE including:
                </p>
                <p>
                  {' '}
                  3a. Facilitating lending and non-lending products offered by
                  the Company.
                </p>
                <p>
                  {' '}
                  3b. Facilitating lending and non-lending products offered by
                  other lending lending/non-lending partners.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_2"
              >
                <p>Acceptance of terms and conditions</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_2">
                <p>
                  By registering or using the platform in any manner, you agree
                  to all the terms and conditions contained herein. You are
                  advised to carefully read and fully understand the said terms
                  and conditions and in case you do not agree to any of these
                  terms and conditions, you shall cease to visit and use the
                  platform or use the services. These terms and conditions shall
                  apply to all users and visitors of the platform.
                </p>
              </div>
            </div>

            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#refund-policy"
              >
                <p>Refund and Cancellation Policy</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="refund-policy">
                <p className="bold-text">eSwarna Digital Gold</p>
                <p>
                  Please note, once an order for purchase or sale has been
                  confirmed by the customer, refunds or cancellation is not
                  possible. All orders are final upon customer confirmation. The
                  convenience fee paid for a eSwarna Digital Gold transaction is
                  non-refundable as this fee covers the payment gateway charges.
                  If any payment has been debited from your UPI account, and the
                  gold is not credited in your Muthoot FinCorp ONE gold balance,
                  an automatic refund will be initiated by Muthoot FinCorp ONE,
                  and the amount will be credited to your bank account within
                  5-7 working days. You may also contact our customer care team
                  at customercare@muthoot.com for any further queries or status
                  updates
                </p>
                <p className="bold-text">Recharge and Bills</p>
                <p>
                  Recharges of your Mobile/DTH/Datacard and other utility
                  payments are real time transactions and once the transaction
                  is successful there will be no refund or exchange permitted.
                  Please be alert that you are responsible for accuracy of the
                  details entered by You to make a payment and/ or recharges and
                  all charges that result from those recharges/services. Muthoot
                  FinCorp ONE is not responsible for any recharge/service for an
                  incorrect mobile number,DTH account number, Data card mobile
                  number and other utility payments.
                </p>
                <p>
                  You further agree that Muthoot FinCorp ONE will not be liable
                  for any failure on the part of any Biller in effecting a
                  recharge or other bill payment or for any issue related to the
                  quality of service provided by the Biller, and any dispute
                  relating to the same shall be resolved directly between you
                  and the Biller.
                </p>
                <p>
                  If you face any payment-related issues, click the “Help &
                  Support” section and contact us to raise your query. We will
                  assist you through our Helpcenter.
                </p>
                <p>
                  Refund,of payment amount for bill payment including mobile
                  recharge or for any payment debited from your account for
                  which the bill payment or recharge is unsuccessful, will be
                  solely as per the terms or policies of the Biller, and you
                  agree that Muthoot FinCorp ONE will not be responsible for the
                  same
                </p>
                <p>
                  Kindly note that the convenience fee paid for a successful
                  Recharge & Bill payment shall be non-refundable as the same
                  shall be incurred by us towards Payment gateway charges.
                </p>
                {/* <p className="bold-text">Pay Rent and Vendors</p>
                <p>
                  At Muthoot FinCorp ONE, the user is at own freewill to use the
                  platform for remitting rental payments and is not bound by any
                  contract for mandatory use. Users shall have very well
                  understood and acknowledge that payments when made into a bank
                  account of your registered landlord are irreversible as the
                  same falls under the personal jurisdiction of the said person.
                  The service here refers to remittance of rent amount from your
                  bank account and Muthoot FinCorp ONE will not be liable to
                  reverse such payments. As the service once rendered is
                  irreversible, the user shall not be entitled for any refunds
                  in case of successfully remitted payments to landlords.
                </p>
                <p>
                  There shall be NO REFUNDS or REVERSAL of any kind for
                  successfully remitted rental payments. However, the user shall
                  be fully refunded for any kind of debits on account of
                  technical failure on the website. Technical failure in this
                  context refers to a deviation from the established payment
                  process on our website without an acknowledgement to the user
                  on the successful remittance of the payment. In such a case,
                  the user shall be refunded the entire amount, including the
                  service fees (if any), without any demur into his account
                  within 7 to 10 working days
                </p> */}
                <p className="bold-text">Forex</p>
                <p>
                  In the case of the cancellation or failure to complete a fixed
                  rate order , the deposit is either partially refunded to you
                  or revoked in full depending on the loss sustained by our
                  affiliate money changer as a result of the forex
                  cancellations.
                </p>
                <p>
                  In case the user fails to avail lock-in rate within 48 hours,
                  then the service charge of 2% for lock-in rate will be
                  considered as forfeited by the user.
                </p>
                <p>
                  No obligation orders cannot be cancelled once the actual
                  transaction has been executed.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_3"
              >
                <p>Signing up and On-Boarding</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_3">
                <p>
                  A user is required to create a profile/sign up on the Platform
                  by entering his/her mobile number and other details. By
                  submitting the basic details you agree to accept all these
                  terms and conditions. The user shall also be required to
                  accept all other terms and conditions of the Company or its
                  lending partners for availing any lending or non-lending
                  services. Registration as a user and creation of profile is a
                  one-time process, thereafter the user can login to their
                  profile anytime using their credentials.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_4"
              >
                <p>Eligibility</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_4">
                <p>
                  The user declares and agrees that the user is a natural/ legal
                  person who has attained the age of 18 years and can legally
                  enter into a contract in India. If the user violates any of
                  these terms and conditions and if Muthoot FinCorp ONE believes
                  that the user in under the age of 18 years, Muthoot FinCorp
                  ONE may terminate or delete the user’s profile/any content and
                  information or prohibit the user from using or accessing the
                  platform with or without any notice.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_5"
              >
                <p>Representation and Warranties</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_5">
                <p>
                  Muthoot FinCorp ONE does not make any representations or
                  warranties on behalf of any lending partners/NBFCs partnered
                  with us for offering any lending and non-lending services on
                  the Platform. Muthoot FinCorp ONE shall be only responsible
                  for providing the services. All liabilities and obligations of
                  the user with respect to any lending and non-lending products
                  offered by any lending partners shall be governed by the
                  separate agreement executed between such respective lending
                  partner/NBFC and the user. The user acknowledges that Muthoot
                  FinCorp ONE shall have absolutely no liability with respect to
                  the same.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_6"
              >
                <p>Redirection and Third Party Services</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_6">
                <p>
                  Muthoot FinCorp ONE may partner with third party entities
                  (such as banks, NBFCs, financial institutions, etc.) to list,
                  display or present such third party’s services and products on
                  the Platform or embed links/ hyperlinks to third party
                  platforms. In order to avail the third party services and
                  products, the Platform, upon your action and/or request, will
                  redirect you to the concerned third-party’s website, link,
                  mobile application, page or platform (“Third Party Platform”).
                  Post redirection, the digital journey moves from outside of
                  MFL Platform, and onto the Third Party Platform. MFL does not
                  own, control or endorse the Third Party Platform or its
                  products/services, nor does it undertake any liability,
                  responsibility or warranty of the content, product, services
                  or the reliability of any service, statement or other
                  information displayed or provided on the Third Party Platform
                  whatsoever. Any payments made or information shared on the
                  Third Party Platform shall be truly at User’s sole discretion,
                  without MFL’s involvement.
                  <br />
                  <br />
                  The User agrees to undertake its own prudence and judgment
                  while availing any products/ services offered or relying on
                  any opinion, statement, or information available on the Third
                  Party Platform. MFL will have no liability or responsibility
                  for any loss (whether direct or indirect) suffered, claim made
                  or damage caused to you due to the Third Party Platform. The
                  information and service available on the Third Party Platform
                  may be subject to change, updation, revision, verification and
                  amendment at the discretion of the third party, without notice
                  and such information may change materially, without any
                  involvement of MFL.
                  <br />
                  <br />
                  All intellectual property rights in and to Third Party
                  Platform and services/products offered are the property of the
                  respective third parties. The User understands and
                  acknowledges that MFL shall not be held liable for any
                  liabilities whatsoever including but not limited to fraud,
                  misrepresentation incident due to sharing of details by the
                  user on such Third Party Platform.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_7"
              >
                <p>Privacy</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_7">
                <p>
                  When you submit your personal information on our platform, you
                  expressly give consent to Muthoot FinCorp ONE for collection,
                  use, sharing of the information as per our privacy policy.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_8"
              >
                <p>Acknowledgements</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_8">
                <p>
                  By consenting to these terms and conditions you acknowledge
                  that:
                </p>
                <p>
                  Muthoot FinCorp ONE is a platform facilitating lending and
                  non-lending transactions between users and the Company and
                  other lending partners which are registered with The Reserve
                  Bank of India. Muthoot FinCorp ONE is not engaged in granting
                  of loans and is not responsible for sanctioning of such loans.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_9"
              >
                <p>Disclaimers</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_9">
                <p>
                  Muthoot FinCorp ONE does not warrant or guarantee the
                  performance of a third-party service provider providing
                  services through this Platform. Muthoot FinCorp ONE shall
                  stands exonerated from any claims /damages arising out of its
                  lending and non-lending products provided by the lending
                  partners/NBFCs.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_10"
              >
                <p>Consent to Use or Share Data/Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_10">
                <p>
                  You agree that Muthoot FinCorp ONE or Company or lending
                  partner or any third-party service providers, may collect and
                  use users’ information in accordance with respective privacy
                  policy. Muthoot FinCorp ONE shall endeavour to take all
                  possible steps to maintain secrecy and confidentiality of
                  information provided by users but shall not be liable to the
                  Users for any damages whatsoever caused on account of breach
                  of secrecy/confidentiality due to but not limited to reasons
                  beyond the control of the Muthoot FinCorp ONE or its service
                  providers.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_11"
              >
                <p>Modifications</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_11">
                <p>
                  Muthoot FinCorp ONE shall reserves the right to change,
                  modify, add or remove any aspect of the website/platform, its
                  contents or any of these terms and conditions at any time, in
                  whole or in part, at our sole discretion. Any changes to these
                  terms and conditions will be posted on our website/platform.
                  You agree to examine these conditions on a regular basis to
                  stay informed of any changes.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_12"
              >
                <p>Termination</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_12">
                <p>
                  Muthoot FinCorp ONE reserves rights to suspend and terminate
                  your use of the services and your access to platform without
                  giving prior notice, without any liability or providing
                  adequate reason to you at its sole and absolute discretion.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_13"
              >
                <p>Law, Jurisdiction and Resolution</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_13">
                <p>
                  The provisions of this terms and conditions shall be governed
                  by and, construed in accordance with the Indian Laws and the
                  courts of Trivandrum shall have a jurisdiction to deal with
                  any dispute arising out of this document. You understand that
                  we may need to share information that you provided on the
                  platform to satisfy applicable law, regulation, legal process
                  or an enforceable governmental request.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_14"
              >
                <p>Contact</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_14">
                <p>
                  In case if you may want to share your concern, we welcome you
                  to easily reach out to us through multiple contact options
                  displayed on our website{' '}
                  <a href="https://www.muthootfincorpone.com/">
                    muthootfincorpone.com
                  </a>
                </p>
              </div>
            </div>

            {/* new */}
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_15"
              >
                <h2 className="text--black text--semi mt-1">
                  Insurance Offerings
                </h2>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_15">
                <p>
                  We, Muthoot Fincorp Limited, having registered office at TC
                  NO. 26/286, MUTHOOT CENTRE, PANKAJ TOWERS, PUNNEN ROAD,
                  TRIVANDRUM, Thiruvananthapuram, Kerala, 695034 , (hereinafter
                  referred to as “we” or “us”). At MFL, we value your trust and
                  respect. This T&C provides you (hereinafter referred to as
                  “You” or “Yours” or “customer”) with details about the manner
                  in which we facilitate the insurance offering. You are advised
                  to read this T&C carefully. By availing the services, you
                  expressly give us consent to use & disclose your personal
                  information in accordance with this T&C. If you do not agree
                  to these terms & conditions, please do not use or access the
                  offerings.
                </p>

                <p>
                  1. By continuing, you confirm that you are (a) a resident of
                  India; (a) have attained the age of 18 years.
                </p>
                <p>
                  {' '}
                  2. By making use of the App, and furnishing your
                  personal/contact details, you hereby agree that you are
                  interested in availing and purchasing the Group Insurance
                  Policy (&quot;Policy&quot;) that you have selected. You hereby
                  agree that Muthoot Fincorp Limited (&quot;MFL&quot;) may
                  contact you either electronically, through phone or through
                  any other medium, to understand your interest in the Policy.
                  You hereby explicitly provide consent to receive promotional
                  materials and/or special offers from us through email or SMS
                  or any other communication mode(s).
                </p>
                <p>
                  {' '}
                  3. MFL is not an Insurance broking license holder nor a
                  Corporate Insurance Agent; therefore we are able to offer only
                  Group Insurance Policies (&quot;Policy&quot;) to our existing
                  customers with whom we have an affinity or a relationship.
                  <br />
                  In addition to facilitating Policy, we may capture customer’s
                  interest including personal data in any of retail Insurance
                  products, for that you are hereby voluntarily providing
                  consent to us for the collection, processing, share of their
                  data/information/details with Muthoot Risk Insurance and
                  Broking Services (&quot;MRIBS&quot;).
                </p>
                <p>
                  {' '}
                  4. Any Policy solicited by us is issued by the Insurer. We do
                  not underwrite the risk or act as an Insurer at any time. The
                  risk is underwritten by the Insurer only.
                </p>
                <p>
                  {' '}
                  5. Currently, we are offering three Policies through our
                  branches -
                  <br />
                  {/* <div style={{ marginLeft: "40px" }}>
                    <p>a. Muthoot Health Guard;</p>
                    <p>b. Muthoot Dhan Suraksha; and</p>
                    <p>c. Muthoot Jeevan Suraksha.</p>
                  </div> */}
                  <span className="om-tnc-ol">a. Muthoot Health Guard;</span>
                  <span className="om-tnc-ol">
                    b. Muthoot Dhan Suraksha; and{' '}
                  </span>
                  <span className="om-tnc-ol">c. Muthoot Jeevan Suraksha.</span>
                  We may offer a few more Policies to our existing customers as
                  per the requirement from customers including but limited to:
                  <span className="om-tnc-ol">
                    a. Motor Insurance (includes 2-wheeler, 3-wheeler, 4-wheeler
                    and commercial vehicle Insurance); and
                  </span>
                  <span className="om-tnc-ol">b. Life Insurance</span>
                </p>
                <p>
                  {' '}
                  6. You may purchase Insurer&apos;s insurance policies at your
                  sole discretion and purely on a voluntary basis.
                </p>
                <p>
                  {' '}
                  7. The contract of Policy will be between the Insurer and you,
                  to the exclusion of us. Accordingly, we are not responsible or
                  liable for performance or enforcement of any of your benefits
                  or rights under the contract of insurance with the Insurer.
                  Any disputes arising in relation to the contract of insurance
                  are between you and the Insurer.
                </p>
                <p>
                  {' '}
                  8. For more details on risk factors, product details, terms
                  and conditions and exclusions please read the relevant product
                  brochure carefully before the conclusion of sale.
                </p>
                <p>
                  {' '}
                  9. The information provided on the App is only for information
                  sake. Information in relation to the Policy is solely based on
                  the information received from the Insurer. You may also visit
                  the website of the Insurer for insurance requests. Purchase of
                  insurance is not a pre-condition of availing of any other
                  services offered by us. We do not guarantee the accuracy of,
                  and disclaim all liability for any errors or other
                  inaccuracies relating to the information and description of
                  the content, products, and Services offered on the App. We
                  expressly reserve the right to correct any pricing errors on
                  the App and/or on pending reservations made under an incorrect
                  price or differential price.
                </p>
                <p>
                  {' '}
                  10. All information, content, materials, and Policy included
                  on or otherwise made available to you are provided by us on an
                  &quot;as is&quot; and &quot;as available&quot; basis unless
                  otherwise specified in writing. We disclaim all
                  representations or warranties, express or implied, with
                  respect to the operation of App, including without limitation,
                  any express or implied representation or warranty of
                  merchantability or fitness for a particular purpose. If
                  applicable law does not allow limitations on implied
                  warranties or the exclusion or limitation of certain damages,
                  some or all of the above disclaimers, exclusions, or
                  limitations may not apply to you, and you may have additional
                  rights. In no event will we or our directors, officers,
                  employees, agents or other representatives be liable for any
                  indirect, special, incidental, consequential, or punitive
                  damages, or any other damages of any kind, arising out of or
                  related to the Services.
                </p>
                <p>
                  {' '}
                  11. Based on the Insurance policy type, there may be a
                  free-look period, as per the Insurer’s policy, during which
                  the customer can opt to cancel his policy and get a full
                  refund of the payment made
                </p>
                <p>
                  {' '}
                  12. By opting to purchase Insurance, the customer explicitly
                  agrees and authorizes Muthoot Fincorp Limited to share his
                  personal data with the Insurer for the purpose of issuance and
                  other ancillary policy services, underwriting and servicing of
                  the purchased policy.
                </p>
                <p>
                  {' '}
                  13. MRIBS is the Insurance broker who is associated with the
                  above-mentioned group policies and MFL along with MRIBS shall
                  assist customers in any aspect pertaining to Insurance claims
                  and servicing;
                </p>
                <p>
                  {' '}
                  14. We are only collecting or assisting in collecting the
                  premium amount on behalf of the Insurer and the same is
                  transferred to the Insurer on a daily basis. The acceptance of
                  the amount as premium and final issuance of the policy is
                  subject to the underwriting norms and discretion of the
                  Insurer, over which MFL has no control.
                </p>
                <p>
                  {' '}
                  15. When you use the App or send emails to us, you are
                  communicating with us electronically. You consent to receive
                  communications from us electronically. We may communicate with
                  you by email, by notifications on the App, by phone or using
                  any other means of communication. You agree that all
                  agreements, notices, disclosures and other communications that
                  we provide to you satisfy any legal requirement that such
                  communications be in writing.
                </p>
                <p>
                  {' '}
                  16. For claims and any kind of grievances pertaining to
                  Insurance, the customer can reach out to the following:
                  <span className="om-tnc-ol">
                    a. MFL support email id:{' '}
                    <a href="mailto:insurance@muthoot.com">
                      insurance@muthoot.com
                    </a>
                  </span>
                  <span className="om-tnc-ol">
                    b. MRIBS contact details:{' '}
                    <a href="tel:04714074828">04714074828</a>
                  </span>
                  <span className="om-tnc-ol">
                    c. Insurer contact details:{' '}
                    <a href="mailto:sponsorsupport@tataaig.com">
                      sponsorsupport@tataaig.com{' '}
                    </a>
                  </span>
                  <span className="om-tnc-ol">
                    d. We reserve the right to make changes to these T&Cs, at
                    any time, in our sole discretion. All terms and conditions
                    are applicable to the extent permitted by law. By continuing
                    usage of the services as per these revised terms, you agree
                    to be bound by such changes/revisions.
                  </span>
                </p>
              </div>
            </div>
            {/*  Digital Gold Rebranding to eSwarna Digital Gold */}
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_16"
              >
                <h2 className="text--black text--semi mt-1">
                  Digital Gold Rebranding to eSwarna Digital Gold
                </h2>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_16">
                <p className="bold-text">1.INTRODUCTION</p>
                <p>
                  <span className="om-tnc-ol">
                    1.1. This document is an electronic record in terms of the
                    information technology act, 2000 and rules thereunder as
                    applicable and the provisions pertaining to electronic
                    records in various statutes as amended by the information
                    technology act, 2000. This electronic record is generated by
                    a computer system and does not require any physical or
                    digital signatures.
                  </span>
                  <span className="om-tnc-ol">
                    1.2. This document is published in accordance with the
                    provisions of rule 3(1) of the information technology
                    (intermediaries guidelines) rules, 2011 that requires
                    publishing the rules and regulations, privacy policy and
                    terms of use for access or usage of the platform.
                  </span>

                  <span className="om-tnc-ol">
                    1.3. Part i and part ii of these terms of use shall be
                    collectively referred to as the ‘terms’ and shall always be
                    read together.
                  </span>
                </p>
                <p className="bold-text">2. DEFINITIONS</p>
                <p>
                  <span className="om-tnc-ol">
                    2.1. For the purpose of these Terms, wherever the context so
                    requires, the term:
                  </span>
                  <span className="om-tnc-ol">
                    2.1.1. “Customer” shall mean any individual, who as the
                    counterparty transacts using the Platform for buying eSwarna
                    Digital Gold (as defined below), or selling back the eSwarna
                    Digital Gold to MUTHOOT EXIM or any other buyer as outlined
                    in these Terms or authorising a transfer of the balance for
                    purchase of gold/jewellery.
                  </span>

                  <span className="om-tnc-ol">
                    2.1.2. “Customer Request” shall mean a Purchase Request,
                    Sale Request or Exchange Request placed by You in relation
                    to the Customer eSwarna Digital Gold balance.
                  </span>
                  <span className="om-tnc-ol">
                    2.1.3. “eSwarna Digital Gold Account Information” shall mean
                    the information provided by You for the purpose of creation
                    of the MUTHOOT EXIM Gold Account.
                  </span>
                  <span className="om-tnc-ol">
                    2.1.4. ““MUTHOOT FINCORP ONE”” shall mean the website or
                    application offered and maintained by MUTHOOT FINCORP Ltd
                    (MFL) which is accessible through the URL
                    https://www.muthootexim.com/
                  </span>

                  <span className="om-tnc-ol">
                    2.1.5. “Force Majeure Event” shall mean any event that is
                    beyond the reasonable control of the Platform Provider
                    and/or MUTHOOT EXIM and shall include, without limitation,
                    sabotage, fire, flood, explosion, act of God, civil
                    commotion, strikes, lockouts or industrial action of any
                    kind, riots, insurrection, war, acts of government, computer
                    hacking, civil disturbances, unauthorised access to computer
                    data and storage device, computer crashes, virus attacks,
                    breach of security and encryption, government orders or
                    restrictions to movement applicable, including as a result
                    of any pandemic, and any other similar events not within the
                    control of the Platform Provider and/or MUTHOOT EXIM and
                    which the Platform Provider and/or MUTHOOT EXIM is not able
                    to overcome
                  </span>

                  <span className="om-tnc-ol">
                    2.1.6. “Payment Instrument” shall mean any electronic modes
                    of payment for the transmission or payment of money.
                  </span>

                  <span className="om-tnc-ol">
                    2.1.7. &quot;Person” shall mean an individual, a
                    corporation, a partnership, a joint venture, a trust, an
                    unincorporated organization and any other legal entity.
                  </span>
                  <span className="om-tnc-ol">
                    2.1.8. &quot;Platform&quot; shall mean, and include, the
                    mobile application, website and Branch Stores operated by
                    MFL and its affiliates, through which the Customer accesses
                    any content, services and technology pertaining to
                    transactions in eSwarna Digital Gold.
                  </span>
                  <span className="om-tnc-ol">
                    2.1.9. “eSwarna Digital Gold” shall mean 24 karat gold of
                    99.5% purity or higher, offered to the Customer by MUTHOOT
                    EXIM under the brand name “eSwarna Digital Gold”.
                  </span>

                  <span className="om-tnc-ol">
                    2.1.10. “Digital Gold Account” shall mean the account
                    created on the Platform whether by You or otherwise, in
                    accordance with these Terms.
                  </span>

                  <span className="om-tnc-ol">
                    2.1.11. “Transfer” refers to a facility to transfer Gold
                    from eSwarna Digital Gold Account to another Gold Account.
                  </span>

                  <span className="om-tnc-ol">
                    In addition to the terms defined in Section 2.1, additional
                    terms used herein shall have the respective meanings
                    assigned thereto in the relevant sections contained
                    hereinafter.
                  </span>
                </p>

                <p className="bold-text">
                  3. TERMS AND CONDITIONS OF SERVICES BEING PROVIDED BY MUTHOOT
                  EXIM
                </p>

                <p>
                  <span className="om-tnc-ol">
                    3.1. MUTHOOT EXIM PRIVATE LIMITED, a company incorporated
                    under the Companies Act, 2013 with its registered office at
                    40/7384 Muthoot Towers, M.G. Road, Ernakulum, Kerala-
                    682035, (&quot;MUTHOOT EXIM &quot;) will be selling gold and
                    providing services of safe keeping/vaulting and
                    delivery/fulfilment of gold and related services thereto to
                    the Customers, on or through the Platform (“Services”).
                  </span>

                  <span className="om-tnc-ol">
                    3.2. The gold is being offered for purchase and/or sale by
                    MUTHOOT EXIM under its brand name “eSwarna Digital Gold”.
                    The Services are being provided by MUTHOOT FINCORP Ltd (MFL)
                    a Company incorporated under the Companies Act, 1956 having
                    its registered office at Muthoot Centre, TC No 27/ 3022,
                    Punnen Road, Trivandrum - 695001, India though mobile/web
                    application by the name “MUTHOOT FINCORP ONE” (“App”) of
                    MFL, and website at muthootfincorpone.com ( the “Platform
                    Provider”). The Platform Provider may provide payment
                    services, fulfilment services and Customer Support in
                    addressing customer queries.
                  </span>
                  <span className="om-tnc-ol">
                    3.3. The Customers are advised to read and understand these
                    Terms carefully before using the Services.
                  </span>
                  <span className="om-tnc-ol">
                    3.4. MUTHOOT EXIM and/or the Platform Provider do not
                    guarantee any returns, on any transactions consummated
                    vis-à-vis the Platform, to any person, either directly or
                    indirectly. The Customer (hereinafter referred to as “You”,
                    with the term “Your” being construed accordingly) shall be
                    solely responsible for undertaking appropriate and effective
                    due diligence and related analysis before undertaking any
                    transactions pursuant to these Terms of Use. You further
                    acknowledge and agree that MUTHOOT EXIM and/or the Platform
                    Provider and its officers, directors, employees, agents and
                    affiliates will have no liability for Your purchase or other
                    decisions using the Platform.
                  </span>

                  <span className="om-tnc-ol">
                    3.5. The Services by MUTHOOT EXIM shall be provided for a
                    term commencing from the date of creation of the Digital
                    Gold Account.
                  </span>

                  <span className="om-tnc-ol">
                    3.6. You understand and acknowledge that the Services are
                    being provided and made available on an “AS IS” and “AS
                    AVAILABLE” basis. The Platform may contain errors or
                    inaccuracies that could cause failures, corruption or loss
                    of data and/or information from Your device and/or any
                    device used by You to connect to the Platform as well as
                    from peripherals (including, without limitation, servers and
                    computers) connected to any of the above-mentioned devices.
                    You assume all risks and costs associated with Your use of
                    the Services and the Platform, including without limitation,
                    any costs incurred for the use of Your device and any damage
                    to any equipment, software or data.
                  </span>

                  <span className="om-tnc-ol">
                    3.7. You confirm that you are not registered under the Goods
                    and Services Tax Act, 2017 and that if, in the course of
                    your relationship with MUTHOOT EXIM, you become registered
                    under the Goods and Services Tax Act, 2017, you shall inform
                    MUTHOOT EXIM of your change in status immediately, and
                    provide any relevant information and documents, as may be
                    requested.
                  </span>
                </p>

                <p className="bold-text">
                  4. INTERMEDIARIES AND SAFE KEEPING ARRANGEMENT
                </p>
                <p>
                  <span className="om-tnc-ol">
                    4.1. Appointment of Intermediaries
                  </span>
                  <span className="om-tnc-ol">
                    4.1.1. MUTHOOT EXIM may from time to time appoint
                    intermediaries who shall assist MUTHOOT EXIM in providing
                    the Services to You (“Intermediaries”). The term,
                    “Intermediaries” shall mean the , Vault Keeper and shall
                    include any and all Persons appointed by MUTHOOT EXIM upon
                    placement of a Customer Order (and successful payment of
                    monies in lieu thereof) till the consummation of the
                    Customer Requests placed by You in accordance with these
                    Terms. You hereby consent to the appointment of such
                    Intermediaries, for and on Your behalf, by MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">
                    4.1.2. You acknowledge and understand that these
                    Intermediaries have been appointed to ensure that Your
                    Customer Orders/Customer Requests are duly complied with in
                    accordance with these Terms. You additionally acknowledge
                    that certain payments will have to be made to these
                    Intermediaries for their appointment and services in
                    relation thereto, which shall be borne by MUTHOOT EXIM on
                    Your behalf unless otherwise indicated in these Terms.
                  </span>
                  <span className="om-tnc-ol">
                    4.3. Safe Keeping/Vaulting of Customer eSwarna Digital Gold
                    Balance
                  </span>
                  <span className="om-tnc-ol">
                    4.3.1. eSwarna Digital Gold purchased by You corresponding
                    to the Customer Order shall be stored with a custodian in a
                    vault on Your behalf (“Vault Keeper”).
                  </span>
                  <span className="om-tnc-ol">
                    4.3.2. You hereby authorize (i) appointment of such Vault
                    Keeper to safe keep the gold purchased; and (ii) MUTHOOT
                    EXIM to store such eSwarna Digital Gold products purchased
                    by You, including, but not limited to, bullion or coins (as
                    the case may be) in the secured vault on Your behalf
                    (“Customer Gold”). It is hereby clarified that Your purchase
                    of the gold corresponding to the Customer Order shall be
                    deemed to be completed and title in relation thereto shall
                    be deemed to have been passed, upon such relevant portion of
                    the Customer Gold being stored in the vault with the Vault
                    Keeper on Your behalf or upon a final invoice being issued
                    by MUTHOOT EXIM in accordance with these Terms, subject to
                    applicable laws.
                  </span>
                  <span className="om-tnc-ol">
                    4.3.3. To ensure that the Customer Gold stored in such vault
                    is adequately protected, necessary insurance policy/ies has
                    been obtained by the Vault Keeper, where the cost of
                    insurance to safe keep the same will be borne by the Vault
                    Keeper. Pursuant to such insurance policy/ies, for any loss
                    or damage to the Customer Gold stored in the vault, You
                    further authorize the MUTHOOT EXIM to act as Your
                    beneficiary under the insurance policy/ies and to take all
                    steps necessary to protect Your interests.
                  </span>
                  <span className="om-tnc-ol">
                    4.3.4. While the Vault Keeper has taken the necessary
                    insurance policy/ies, in case of occurrence of an event not
                    covered in such insurance policy/ies, the Customer Gold may
                    be at risk. The insurance policy/ies obtained by the Vault
                    Keeper are in line with the global industry practices and
                    cover losses due to fire, lightning, theft, cyclone,
                    earthquake, flood, etc. but do not cover losses due to
                    events such as war, revolution, derelict weapons of war,
                    nuclear radiation, etc.
                  </span>
                </p>
                <p className="bold-text">
                  5. TRANSFER OF eSWARNA DIGITAL GOLD BALANCE
                </p>
                <p>
                  <span className="om-tnc-ol">
                    5.1. MUTHOOT EXIM may offer You the ability to transfer your
                    gold to another recipient, by means of the “gift” feature,
                    or as part of another product function such as exchanging
                    your eSwarna Digtal Gold Balance purchased through the
                    Platform for jewellery/Gold.
                  </span>
                  <span className="om-tnc-ol">
                    5.2. It is expressly clarified that functionality for
                    exchanging your eSwarna Digital Gold Balance purchased on
                    the Platform for jewellery shall be available only at
                    Branches or it will be delivered to the customer at a
                    convenient location.
                  </span>
                  <span className="om-tnc-ol">
                    5.3. Any such transfer of gold from you to another recipient
                    shall only be valid if exercised through a method or
                    functionality offered by MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">5.4. Gifting Gold:</span>
                  <span className="om-tnc-ol">
                    5.4.1. MUTHOOT EXIM may offer Customers the ability to gift
                    Gold purchased by the Customer, to a recipient of their
                    choice. This will be offered as the “gift gold” feature.
                  </span>
                  <span className="om-tnc-ol">
                    5.4.2. Neither MUTHOOT EXIM nor the Platform Provider shall
                    be responsible for the acceptance or rejection of the “gift”
                    by the intended recipient, or for verifying the correctness
                    of the mobile number or other identification information
                    provided for the intended recipient by the Customer.
                  </span>
                  <span className="om-tnc-ol">
                    5.4.3. Gold gifts shall be final, and MUTHOOT EXIM shall not
                    be responsible for amending, altering or otherwise reversing
                    the transaction in case the gift is delivered to an
                    unintended recipient due to any error on the part of the
                    Customer.
                  </span>
                  <span className="om-tnc-ol">
                    5.4.4. However, in case the intended Recipient does not
                    accept the “gift” within the prescribed time, the Customer
                    eSwarna Digital Gold balance shall revert to the Customer’s
                    eSwarna Digital Gold Account.
                  </span>
                  <span className="om-tnc-ol">
                    5.5. Exchange for Jewellery/Gold
                  </span>
                  <span className="om-tnc-ol">
                    5.5.1. Customers shall be able to exchange their eSwarna
                    Digital Gold Balance for jewellery exclusively through the
                    Platform Provider, i.e. through MFL Branches or platforms
                    offered by MUTHOOT EXIM. This will be offered as part of the
                    “exchange for jewellery/gold” feature.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.2. Customers may opt for this functionality by following
                    the procedure described on the Platform, as offered by
                    MUTHOOT EXIM. The transaction shall only be initiated upon
                    the express instructions of the Customer to the Platform
                    Provider.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.3. Customers will be sent an OTP by MUTHOOT EXIM to
                    verify the transaction and confirm that they wish to proceed
                    with the transfer of eSwarna Digital Gold Balance to the
                    Platform Provider. By communicating the OTP to the Platform
                    Provider, You agree to allow MUTHOOT EXIM to debit your
                    eSwarna Digital Gold account balance to the extent required
                    for the purchase of your chosen jewellery product/Gold.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.4. Any additional charges for the jewellery product
                    selected shall be borne by the Customer.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.5. You may note that the gold rate as applicable in the
                    platforms will be applicable for the purchase of jewellery.
                    Further, other purchase terms and conditions may be imposed
                    by the Platform Provider for purchase of jewellery.
                  </span>

                  <span className="om-tnc-ol">
                    5.5.6. Once a transaction has been deemed to be final and an
                    invoice generated for the transaction, Customers shall not
                    have the ability to cancel or request for a refund, unless
                    specifically allowed by MUTHOOT EXIM or the Platform
                    Provider.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.7. The Platform Provider at its sole discretion may
                    extend discounts for purchase of jewellery/gold.
                  </span>
                  <span className="om-tnc-ol">
                    5.5.8. Once a transaction is deemed to be final, any
                    disputes with respect to the jewellery product/gold selected
                    shall be resolved directly between the Platform Provider and
                    the Customer.
                  </span>
                </p>

                <p className="bold-text">6. STORAGE OF GOLD</p>
                <p>
                  <span className="om-tnc-ol">
                    6.1. You are required to take delivery of Your Customer Gold
                    within such maximum period as shall be specified for this
                    purpose by MUTHOOT EXIM from time to time on the Platform
                    (“Maximum Storage Period”), which is currently limited to 10
                    years from the time of purchase of eSwarna Digital Gold.
                  </span>
                  <span className="om-tnc-ol">
                    6.2. For the purposes of making delivery to You, You are
                    required to provide a valid address and/or any other
                    documents/information/ biometric identification that may be
                    specified in this regard by the Platform Provider and/or
                    MUTHOOT EXIM on the Platform from time to time.
                  </span>
                  <span className="om-tnc-ol">
                    6.3. You may provide such address at any time during the
                    Maximum Storage Period. In the event that no valid address
                    has been provided by You during the Maximum Storage Period,
                    then the Platform Provider and/or MUTHOOT EXIM shall for a
                    period 1 year commencing from the date of expiry of Maximum
                    Storage Period (such period being the “Grace Period”)
                    attempt at least once to contact You using the contact
                    information provided by You to obtain either (i) an address
                    to which You would require the eSwarna Balance in question
                    to be delivered or (ii) Your bank account details into which
                    sale proceeds of the Customer Gold shall be deposited.
                  </span>
                  <span className="om-tnc-ol">
                    6.4. In the event that the Platform Provider and/or MUTHOOT
                    EXIM have not been able to contact You during the applicable
                    Grace Period using the contact information provided by You
                    or where You shall during the Grace Period either fail to:
                  </span>
                  <span className="om-tnc-ol">
                    (a) take delivery of the gold in question for any reason
                    whosoever (including where You shall not have provided any
                    address to take delivery of such gold); or
                  </span>
                  <span className="om-tnc-ol">
                    (b) provide the details for a valid bank account into which
                    the proceeds of any sale of such Customer Gold is to be
                    deposited;then upon expiry of the applicable Grace Period
                    for the Customer Gold in question, MUTHOOT EXIM shall
                    purchase such Customer Gold with the purchase price being
                    the applicable prevailing price displayed on the Platform
                    for purchase of eSwarna Digital Gold from Customers and will
                    be sold by MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">
                    6.5. The purchase proceeds realized from such sale (“Final
                    Sale Proceeds”) after deducting any amounts payable to
                    MUTHOOT EXIM as storage charges for storage of such gold
                    after the Free Storage Period, shall be deposited into a
                    bank account operated by the MUTHOOT EXIM, who shall be the
                    sole signatory to such bank account.
                  </span>
                  <span className="om-tnc-ol">
                    6.6. In the event that You shall during a period of 3 years
                    commencing from the date of expiry of the applicable Grace
                    Period (such period being the “Final Claim Period”) notify
                    either The Platform Provider or, MUTHOOT EXIM that You are
                    claiming the applicable Final Sale Proceeds, MUTHOOT EXIM
                    shall issue suitable instructions to transfer the Final Sale
                    Proceeds to such bank account as You shall notify for this
                    purpose.
                  </span>
                  <span className="om-tnc-ol">
                    6.7. Please note that to claim the Final Sale Proceeds You
                    will be required to provide details of a valid bank account
                    and that the Final Sale Proceeds will not be transferred in
                    the absence of such details. At no time will the Final Sale
                    Proceeds be paid to you in cash.
                  </span>
                  <span className="om-tnc-ol">
                    6.8. In the event that You shall not claim Your Final Sale
                    Proceeds within the Final Claim Period, then the Final Sale
                    Proceeds shall be transferred to the Prime Minister’s Relief
                    Fund or such other fund as You may designate for this
                    purpose at any time prior to the expiry of the Grace Period.
                  </span>
                </p>
                <p className="bold-text">7. FORCE MAJEURE</p>
                <p>
                  <span className="om-tnc-ol">
                    If performance under these Terms is prevented, restricted,
                    delayed or interfered with by reason of labour disputes,
                    strikes, acts of God, floods, lightning, severe weather,
                    shortages of materials, rationing, inducement of any virus,
                    pandemic, government mandated lockdown, Trojan virus or
                    other disruptive mechanisms, any event of hacking or illegal
                    usage of the Platform, utility or communication failures,
                    earthquakes, war, revolution, acts of terrorism, civil
                    commotion, acts of public enemies, blockade, embargo or any
                    law, order, proclamation, regulation, ordinance, demand or
                    requirement having legal effect of any government or any
                    judicial authority or representative of any such government,
                    or failure of any device used to access the Platform, or any
                    other act whatsoever, whether similar or dissimilar to those
                    referred to in this section, which are beyond the reasonable
                    control of the Platform Provider and/or MUTHOOT EXIM and
                    could not have been prevented by reasonable precautions then
                    the Platform Provider and/or MUTHOOT EXIM shall be
                    discharged from such performance to the extent of and during
                    the period of such force majeure event. Such non-performance
                    by the Platform Provider and/or MUTHOOT EXIM shall, in no
                    manner whosoever, amount to a breach of its obligations
                    herein.
                  </span>
                </p>
                <p className="bold-text">
                  8. TERMINATION OF SERVICES BY MUTHOOT EXIM
                </p>
                <p>
                  <span className="om-tnc-ol">
                    8.1. MUTHOOT EXIM, in its sole discretion, may modify,
                    suspend, or terminate access to or may require the Platform
                    to modify, suspend, or terminate access to, all or any
                    portion of the Platform or Your ability to access any
                    Services through the Platform at any time for any reason
                    including termination for breach of any of these Terms or
                    occurrence of a Customer Event of Default or the Privacy
                    Policy.
                  </span>
                  <span className="om-tnc-ol">
                    8.2. The term “Customer EOD” shall mean any default by a
                    Customer of its obligations owed to MUTHOOT EXIM
                  </span>
                  <span className="om-tnc-ol">
                    8.3. These Terms shall further stand terminated:
                  </span>
                  <span className="om-tnc-ol">
                    8.3.1. if MUTHOOT EXIM is adjudged bankrupt or declared
                    insolvent;
                  </span>
                  <span className="om-tnc-ol">
                    8.3.4. upon any corporate action (excluding any third party
                    corporate action), legal proceedings or other procedures or
                    steps being taken in relation to the suspension of payments,
                    winding up, dissolution, administration, provisional
                    supervision or reorganization or restructuring (by way of
                    voluntary arrangement, scheme of arrangement or otherwise)
                    of MUTHOOT EXIM;
                  </span>
                  <span className="om-tnc-ol">
                    8.3.5. upon MUTHOOT EXIM commencing a voluntary proceeding
                    under any applicable bankruptcy, insolvency, winding up or
                    other similar applicable law now or hereafter in effect, or
                    consenting to the entry of an order for relief in an
                    involuntary proceeding under any such applicable law, or
                    consenting to the appointment or taking possession by a
                    receiver, liquidator, assignee (or similar official) for the
                    whole or a substantial part of its property or takes any
                    action towards its re-organization, liquidation or
                    dissolution;
                  </span>
                  <span className="om-tnc-ol">
                    8.3.6. upon an order being made for the winding up,
                    bankruptcy or dissolution of MUTHOOT EXIM, or an application
                    is admitted for initiating any corporate insolvency
                    resolution process against MUTHOOT EXIM in accordance with
                    Applicable Law;
                  </span>
                  <span className="om-tnc-ol">
                    8.3.7. upon any encumbrancer lawfully taking possession, or
                    a liquidator, judicial custodian, receiver, administrative
                    receiver or trustee or any analogous officer having been
                    appointed in respect of the whole or a substantial part of
                    the property of MUTHOOT EXIM, or an attachment,
                    sequestration, distress or execution (or analogous process)
                    being levied or enforced upon or issued against whole or a
                    substantial part of the assets or property of MUTHOOT EXIM,
                    or any action has been taken or suffered against MUTHOOT
                    EXIM towards liquidation or dissolution or similar
                    reorganization; or
                  </span>
                  <span className="om-tnc-ol">
                    8.3.8. upon a liquidator or provisional liquidator being
                    appointed to MUTHOOT EXIM or a receiver, receiver and
                    manager, trustee or similar official being appointed in
                    respect of MUTHOOT EXIM or any of its assets, or an event
                    analogous.
                  </span>
                  <span className="om-tnc-ol">
                    8.4. Upon the happening of any of the events referred to in
                    Section8.2 2, and where there is any insufficiency of
                    MUTHOOT EXIM funds required to pay any costs and expenses to
                    be incurred in relation to providing delivery of Your
                    Customer Gold to You, then in such an event You do hereby
                    authorise MUTHOOT EXIM to sell any part of the Customer
                    Gold, that is necessary or required to defray such costs and
                    expenses.
                  </span>

                  <span className="om-tnc-ol">
                    (i) it is not possible to accurately predict the time
                    required to make any such distribution; and/or
                  </span>
                  <span className="om-tnc-ol">
                    (ii) the amount received by You from such distribution may
                    not be sufficient to completely extinguish MUTHOOT EXIM’s
                    liability to You;and consequently, no liability shall accrue
                    to the MUTHOOT EXIM, in relation to the above.
                  </span>
                  <span className="om-tnc-ol">
                    8.7. The Platform Provider may, with or without notice to
                    you, discontinue to make the Services available through the
                    Platform and in such case Your eSwarna Digital Gold Account
                    may be closed and will be dealt with the in the manner
                    specified in Section 18.2 of these Terms.
                  </span>
                </p>
                <p className="bold-text">
                  9. CONSEQUENCES OF TERMINATION OF SERVICES BY MUTHOOT EXIM
                </p>
                <p>
                  <span className="om-tnc-ol">
                    9.1. Upon such termination for any reason whatsoever,
                    subject to these Terms :
                  </span>
                  <span className="om-tnc-ol">
                    9.1.1. Fractional amounts for eSwarna Digital Gold Balance
                    holdings of less than 1 (One) gram may be sold and cash in
                    pursuance thereto will be sent directly to Your bank
                    account, after deducting all the requisite charges relating
                    to appointment of Intermediaries (including but not limited
                    to charges due and payable to Intermediaries and any other
                    out of pocket expenses, custody charges, minting and
                    delivery charges) (“Charges”).
                  </span>
                  <span className="om-tnc-ol">
                    9.1.2. For larger eSwarna Digital Gold Balance holdings, the
                    MUTHOOT EXIM shall (to the extent You have not already paid
                    for all the Charges) be allowed to sell part of Your eSwarna
                    Gold Balance to pay for all the Charges to all the
                    Intermediaries. The remaining portion of the eSwarna Gold
                    Balance Balance shall be delivered to You in accordance with
                    these Terms, along with the details of the deductions made
                    and the quantum of gold that You are entitled to receive.
                  </span>
                  <span className="om-tnc-ol">
                    9.2. You acknowledge that the termination of Your access to
                    the Platform and Services may be affected without any prior
                    notice, and the Digital Gold Account may be immediately
                    deactivated or deleted and all related information and/or
                    bar any further access to the eSwarna Digital Gold Account,
                    the Platform or the Services. Further, You agree that the
                    Platform Provider and/or MUTHOOT EXIM shall not be liable
                    for any discontinuation or termination of Services by any
                    third party.
                  </span>
                  <span className="om-tnc-ol">
                    9.3. None of Your content shall remain accessible on the
                    Platform upon termination. This information cannot be
                    recovered by You, once the account is terminated.
                  </span>
                  <span className="om-tnc-ol">
                    9.4. The disclaimer of warranties, the limitation of
                    liability, and the governing law provisions shall survive
                    any termination of these Terms.
                  </span>
                </p>
                <p className="bold-text">
                  10. GOVERNING LAW AND DISPUTE RESOLUTION
                </p>
                <p>
                  <span className="om-tnc-ol">
                    These Terms shall be governed by and interpreted and
                    construed in accordance with the laws of India. The courts
                    of Mumbai shall have exclusive jurisdiction over any
                    disputes arising under these Terms. In the event of any
                    dispute arising out of these Terms the same shall be settled
                    by a binding arbitration conducted by a sole arbitrator,
                    appointed jointly by both parties and governed by the
                    Arbitration and Conciliation Act, 1996. The venue of
                    arbitration shall be Mumbai, Maharashtra, India.
                  </span>
                </p>
                <p className="bold-text">
                  11. CREATION OF eSwarna Digital GOLD ACCOUNT AND REGISTRATION
                  OBLIGATIONS
                </p>
                <p>
                  <span className="om-tnc-ol">
                    11.1. Before availing the Services, the Customer shall
                    complete registration process as may be prescribed from time
                    to time. The Customer shall follow the instructions given on
                    the Platform for opening a eSwarna Digital Gold Account. The
                    Platform Provider and/or MUTHOOT EXIM shall be entitled to
                    collect and store relevant information and documents
                    provided by the Customer to the Platform for KYC purposes.
                  </span>
                  <span className="om-tnc-ol">
                    11.2. As and when required by MUTHOOT EXIM and/or the
                    Platform Provider, the Customer will be required to provide
                    additional documents for fulfilling the KYC requirements.
                    You authorize MUTHOOT EXIM and the Platform Provider to make
                    such enquiries as may be necessary to satisfy about the
                    validity of your identity. You shall be responsible for the
                    correctness of information provided to MUTHOOT EXIM and the
                    Platform Provider from time to time. If You have reasons to
                    believe that there is an error in the information furnished
                    by You, You shall immediately provide correct / updated
                    information.
                  </span>
                  <span className="om-tnc-ol">
                    11.3. The Platform Provider and/or MUTHOOT EXIM through the
                    Platform Provider, reserves the right to terminate any
                    eSwarna Digital Gold Account, with or without notice to You,
                    in the event that the KYC documents / information are found
                    to be incorrect or authenticity of the documents /
                    information is found to be doubtful. You hereby undertake to
                    indemnify and keep indemnified the Platform Provider and/or
                    MUTHOOT EXIM against any and all losses, claims, liabilities
                    costs etc. which arise out of or relating to Your failure to
                    identify Yourself and validate Your account promptly and /
                    or due to incorrect KYC documents / information.
                  </span>
                  <span className="om-tnc-ol">
                    11.4. Know Your Customer (KYC) and Verification
                  </span>
                  <span className="om-tnc-ol">
                    11.4.1. Prior to placing an order, You may be required to
                    provide certain KYC documentation and other information as
                    may be required by the Platform Provider and/or MUTHOOT EXIM
                    in such form and manner as it may deem fit. This information
                    may be requested from you at the time of registration, or at
                    a later stage.
                  </span>
                  <span className="om-tnc-ol">
                    11.4.2. Once such documentation and other information is
                    provided by You to The Platform Provider, You shall be
                    entitled to place an order on the Platform (“Customer
                    Order”).
                  </span>
                  <span className="om-tnc-ol">
                    11.4.3. You agree that Your continued use of the Platform,
                    consequent upon the creation of the eSwarna Digital Gold
                    Account, is subject to verification by MUTHOOT EXIM and/ or
                    the Platform Provider (on behalf of MUTHOOT EXIM), of the
                    information and documentation provided by You. You hereby
                    grant MUTHOOT EXIM and/ or the Platform Provider permission
                    to conduct such verification, in such form and manner as it
                    may deem fit.
                  </span>
                  <span className="om-tnc-ol">
                    11.4.4. You further acknowledge that MUTHOOT EXIM and/ or
                    the Platform Provider reserves the right for such
                    verification either on registration of the eSwarna Digital
                    Gold Account or at any time thereafter. You hereby authorise
                    MUTHOOT EXIM and/or the Platform Provider to engage with any
                    third-party service provider for verification of your KYC
                    documentation to ascertain your eligibility. Any processing
                    undertaken by MUTHOOT EXIM and/or the Platform Provider to
                    process KYC documents shall be in accordance with its
                    privacy policy and these Terms. It is hereby clarified that
                    as far as the permission to access the KYC documents by a
                    third party service provider is concerned, the same shall be
                    governed by the privacy policy of such third party service
                    provider.
                  </span>
                  <span className="om-tnc-ol">
                    11.5. Customer’s Obligations
                  </span>
                  <span className="om-tnc-ol">
                    11.5.1. You will be responsible for maintaining the
                    confidentiality of eSwarna Digital Gold Account Information,
                    and shall be fully responsible for all activities that occur
                    under your Digital Gold Account. You agree to immediately
                    notify the Platform Provider and/or MUTHOOT EXIM of any
                    unauthorised use of the eSwarna Digital Gold Account
                    Information or any other breach of security. MUTHOOT EXIM or
                    the Platform Provider cannot and will not be liable for any
                    loss or damage arising from Your failure to comply with this
                    section. You may be held liable for losses incurred by
                    MUTHOOT EXIM or the Platform Provider or any user or visitor
                    of the Platform due to authorised or unauthorised use of the
                    eSwarna Digital Gold Account, as a result of your failure in
                    keeping the eSwarna Digital Gold Account Information
                    confidential.
                  </span>
                  <span className="om-tnc-ol">
                    11.5.2. You shall ensure that the eSwarna Digital Gold
                    Account Information provided by You in the registration form
                    is complete, accurate and up-to-date. Use of another
                    Customer’s account information for availing of any of the
                    Services and/or for use of the Platform is expressly
                    prohibited.
                  </span>

                  <span className="om-tnc-ol">
                    11.5.3. You agree that if You provide any information that
                    is untrue, inaccurate, not current or incomplete, (or
                    becomes untrue, inaccurate, not current or incomplete) or if
                    the Platform Provider and MUTHOOT EXIM have reasonable
                    grounds to suspect that such information is untrue,
                    inaccurate, not current, incomplete, or not in accordance
                    with these Terms, the Platform Provider and MUTHOOT EXIM
                    through the Platform Provider shall have the right to
                    indefinitely suspend or terminate or block access to the
                    eSwarna Digital Gold Account on the Platform and refuse to
                    provide You with access to the Platform.
                  </span>
                </p>
                <p className="bold-text">12. PURCHASE OF GOLD</p>
                <p>
                  <span className="om-tnc-ol">
                    12.1. You can offer to buy Gold worth Rs.100.00 (Rupee One
                    Hundred Only) and above incremental value thereof at the
                    market linked prices of gold shown on the Platform. Market
                    linked prices means that these quotes are linked to the
                    prices of gold in the commercial bullion market in India.
                  </span>
                  <span className="om-tnc-ol">
                    12.2. It is hereby clarified that such market linked prices
                    of gold shall constitute fully binding offers and would be
                    an invitation to offer to purchase gold at the said market
                    prices to all Customers. Notwithstanding the foregoing, You
                    understand that these prices may vary multiple times within
                    a day, and accordingly Your payment obligations for any
                    order will depend on the market linked prices then
                    prevailing. While reasonable efforts will be made to offer
                    You a competitive price for the Customer Gold, there is no
                    guarantee that the price offered to You will be close to or
                    comparable with other prices available in the market.
                  </span>
                  <span className="om-tnc-ol">
                    12.3. Payment will be accepted through the payment options
                    made available on the Platform, which may include
                    redirection to a Payment Gateway hosted by other third party
                    website or platform, including by MUTHOOT EXIM. At the time
                    of purchase / fulfilment / sale-back / transfer of eSwarna
                    Digital Gold, the relevant taxes will be chargeable as
                    applicable as per the Government regulations.
                  </span>
                  <span className="om-tnc-ol">
                    12.4. It is hereby clarified that once a Customer Order is
                    placed, You are not entitled to cancel a Customer Order,
                    provided however that a Customer Order shall stand cancelled
                    if the payment fails for any reason whatsoever.
                  </span>
                  <span className="om-tnc-ol">
                    12.5. The Platform Provider and/or MUTHOOT EXIM reserves the
                    right to cancel a Customer Order, at its sole discretion, if
                    Your information, provided prior to placing the Customer
                    Order, is not found acceptable and the Platform Provider
                    and/or MUTHOOT EXIM are of the opinion that You are not
                    eligible to purchase eSwarna Digital Gold. The eSwarna
                    Digital Gold Account shall accordingly stand amended. The
                    Platform Provider as well as MUTHOOT EXIM shall have the
                    right to freeze the eSwarna Digital Gold Account until it
                    receives KYC and other documentation in a form and manner
                    satisfactory to The Platform Provider and MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">
                    12.6. Once the payments are received by MUTHOOT EXIM and the
                    KYC information is found acceptable, MUTHOOT EXIM shall
                    issue an invoice to You confirming the Customer Order placed
                    within a period of 3 (Three) business days of placing such
                    order, in a manner it may deem fit.
                  </span>

                  <span className="om-tnc-ol">
                    12.7. Notwithstanding anything to the contrary contained in
                    these Terms, the Platform Provider and/or MUTHOOT EXIM shall
                    be entitled to accept or reject a Customer, for any reason
                    whatsoever, at its sole discretion.
                  </span>
                  <span className="om-tnc-ol">
                    12.8. In case of rejection of a Customer Order in accordance
                    with these Terms, where payments have been received by
                    MUTHOOT EXIM, such payments shall be returned to You to the
                    bank account linked to your account. subject to the terms
                    and conditions as may be indicated on the Platform.
                  </span>
                </p>
                <p className="bold-text">13. DELIVERY OF GOLD</p>
                <p>
                  <span className="om-tnc-ol">
                    13.1. You shall be entitled to procure delivery of the
                    Customer Gold using the MUTHOOT EXIM Platform (“Delivery
                    Request”), by logging in through Your registered mobile
                    number and utilising your Digital Gold Balance.
                  </span>
                  <span className="om-tnc-ol">
                    13.2. Upon placing the Delivery Request, You shall be
                    required to pay for the applicable charges and confirm the
                    Delivery Request. Your eSwarna Digital Gold Balance shall be
                    provisionally debited corresponding to the quantity of the
                    Customer Gold sought to be delivered (“Delivered Customer
                    Gold”).
                  </span>
                  <span className="om-tnc-ol">
                    13.3. Within a period of 7 (Seven) business days of the
                    Delivery Request being confirmed or such further period as
                    may be required by MUTHOOT EXIM, MUTHOOT EXIM shall arrange
                    for delivery of the Delivered Customer Gold at the shipping
                    address indicated by You. You shall be solely responsible
                    for ensuring that the correct address is furnished by You on
                    the Platform for processing such Delivery Request. You shall
                    not be entitled to change the shipping address after the
                    Delivery Request is processed by MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">
                    13.4. You should carefully examine the package delivered and
                    shall not accept deliveries where the packaging has been
                    tampered with. If, however, You are of the view that the
                    package delivered has been tampered with, You shall be
                    required to intimate MUTHOOT EXIM immediately of the same,
                    and provide such other information as may be required by
                    MUTHOOT EXIM in this regard (“Return Request”). Within a
                    period of 14 (Fourteen) business days of the original
                    package of Delivered Customer Gold being delivered back to
                    MUTHOOT EXIM, in a manner indicated by MUTHOOT EXIM, and the
                    Return Request being approved by MUTHOOT EXIM, MUTHOOT EXIM
                    shall arrange for re-delivery of the Delivered Customer Gold
                    at the shipping address indicated by You. The costs for such
                    shipping shall be borne by MUTHOOT EXIM. However, in the
                    event of frivolous and unjustified Return Requests made by
                    You, MUTHOOT EXIM reserve the right to take all action
                    available to it, including black-listing or blocking You
                    from using the Services.
                  </span>
                  <span className="om-tnc-ol">
                    13.5. You, upon signing the delivery receipt, acknowledge
                    the receipt of the Delivered Customer Gold in terms of the
                    Delivery Request placed with MUTHOOT EXIM. MUTHOOT EXIM
                    shall not be liable to You for any refund/replacement, under
                    any circumstance, for any subsequent complaints with respect
                    to such deliveries and/or any failure on your part (as the
                    case may be) to comply with these Terms.
                  </span>
                  <span className="om-tnc-ol">
                    13.6. Upon receipt of the Delivery Request by MUTHOOT EXIM,
                    the eSwarna Digital Gold Balance shall be debited for the
                    Delivered Customer Gold from the Gold Account.
                  </span>
                  <span className="om-tnc-ol">
                    13.7. It shall be Your responsibility to ensure that You are
                    available to receive the Delivered Customer Gold at the time
                    of delivery. If You are not available at the time of
                    delivery, MUTHOOT EXIM courier agent may try and deliver the
                    item again before returning the same to MUTHOOT EXIM. In
                    case of return of the Delivered Customer Gold to MUTHOOT
                    EXIM, eSwarna Digital Gold Account shall be credited for the
                    Delivered Customer Gold, after deducting the charges (if
                    any) due from You, provided however that MUTHOOT EXIM is of
                    the opinion that the packaging has not been tampered with.
                    It is hereby clarified that should a request for re-delivery
                    be made by You, You shall be solely liable to incur the
                    applicable charges for delivering the Delivered Customer
                    Gold.
                  </span>
                  <span className="om-tnc-ol">
                    13.8. In case of MUTHOOT EXIM’s inability to make deliveries
                    of Delivered Customer Gold due to a Force Majeure Event,
                    MUTHOOT EXIM shall intimate You of the same and may require
                    that the deliveries be effectuated through specific modes.
                    In such a case, You hereby agree to bear any additional
                    costs and fees necessary for the delivery to be complete.
                  </span>

                  <span className="om-tnc-ol">
                    13.9. MUTHOOT EXIM will not be able to deliver a fractional
                    quantity of gold below such threshold as MUTHOOT EXIM shall
                    notify for this purpose even if a Customer Request is made
                    for such fractional quantity (“Threshold Quantity”). You are
                    advised to check the Platform periodically to determine the
                    Threshold Quantity as the same may be revised from time to
                    time. In the event that any Gold below the Threshold
                    Quantity is to be delivered to you, then please note that
                    such Customer Gold shall instead be sold by MUTHOOT EXIM
                    based on the sale prices displayed on the Platform and You
                    will instead receive the applicable sale proceeds in Your
                    bank account, details of which are provided by You. If there
                    is any mistake in the account number provided by You, The
                    Platform Provider and/or MUTHOOT EXIM would not be held
                    responsible for the same.
                  </span>
                  <span className="om-tnc-ol">
                    13.10. Notwithstanding anything to the contrary contained in
                    these Terms, MUTHOOT EXIM shall be entitled to reject a
                    Customer Request which is not in compliance with the Terms
                    hereof, and shall intimate the Customer of the reasons for
                    the same.
                  </span>
                  <span className="om-tnc-ol">
                    13.11. Based on the changes made to the eSwarna Digital Gold
                    Account (in lieu of the Customer Orders and/or Customer
                    Requests), if You are of the opinion that the changes made
                    thereto do not tally with the orders and/or Customer
                    Requests placed by You, You may contact MUTHOOT EXIM at
                    care@e-swarna.in (or such other address as may be
                    communicated on the MUTHOOT EXIM Platform Provider in this
                    regard), who shall accordingly take all necessary actions
                    for taking care of any such identified discrepancies.
                  </span>
                  <span className="om-tnc-ol">
                    13.12. It is hereby clarified that the Customer Gold cannot
                    be pledged or transferred by You to any other user, and the
                    eSwarna Digital Gold Account is non-transferrable, unless
                    specifically allowed by MUTHOOT EXIM. In the event of Your
                    death, if specifically allowed by MUTHOOT EXIM, the title to
                    such Customer Gold lying in the vault and the Gold Account
                    shall transfer to Your legal heirs only after the required
                    due diligence has been conducted. Subsequent to this, Your
                    legal heir(s) shall be regarded as the Customer for the
                    purpose of the Customer Gold and eSwarna Digital Gold
                    Account thereafter and the Terms shall be applicable to Your
                    legal heir(s).
                  </span>
                  <span className="om-tnc-ol">
                    13.13. It is hereby clarified that the Platform displays the
                    articles that are available for shopping. Some items may
                    appear slightly larger or smaller than actual size due to
                    screen defaults and photography techniques. The Platform
                    Provider and MUTHOOT EXIM not be liable for any legal action
                    on this account. It shall be the endeavour of The Platform
                    Provider to ensure that all details regarding the product
                    are clearly displayed on the Platform.
                  </span>
                  <span className="om-tnc-ol">
                    13.14. Due to reasons not directly attributable to MUTHOOT
                    EXIM or the Platform Provider, data may be inaccurately
                    displayed on the Platform due to some system errors on the
                    Platform or any device used to access the Platform. The
                    Platform Provider reserves the right to correct any and all
                    errors when they do occur, at its sole discretion, and the
                    Platform Provider or MUTHOOT EXIM shall be entitled to not
                    honour any requests/orders placed by You based on any
                    inaccurate or erroneous prices.
                  </span>
                  <span className="om-tnc-ol">
                    13.15. The prices quoted on the Platform are fixed and not
                    negotiable. The prices on the Platform are also subject to
                    change without notice to You.
                  </span>
                </p>
                <p className="bold-text">14. SALE OF CUSTOMER GOLD</p>
                <p>
                  <span className="om-tnc-ol">
                    14.1. You may be provided an option to sell the Customer
                    Gold during market hours based on the sale prices on the
                    Platform. If the prices are found acceptable to You, You
                    shall confirm the sale request, in a form and manner
                    acceptable to MUTHOOT EXIM (“Sale Request”). Your eSwarna
                    Digital Gold Account shall be debited corresponding to the
                    quantity of the Customer Gold sought to be sold vide the
                    Sale Request (“Sold Customer Gold”).
                  </span>
                  <span className="om-tnc-ol">
                    14.2. Within a period of 2 (Two) business days of the Sale
                    Request being confirmed or such further period as may be
                    required, the payment, pursuant to the Sale Request, shall
                    be disbursed by MUTHOOT EXIM at the sale prices indicated at
                    the time of placing such Sale Request. MUTHOOT EXIM shall
                    arrange for such payments to be made to Your bank account,
                    details of which are provided by You. If there is any
                    mistake in the account number, IFSC code etc. provided by
                    You, MUTHOOT EXIM would not be held responsible for the
                    same.
                  </span>
                  <span className="om-tnc-ol">
                    14.3. It is hereby clarified that MUTHOOT EXIM and/or the
                    Platform Provider will provide this service on a best
                    efforts basis and only when the commercial bullion market is
                    in operation. MUTHOOT EXIM and the Platform Provider do not
                    in any way guarantee that this option will be available to
                    You at all times. Further, the buyer of the Sold Customer
                    Gold may be either MUTHOOT EXIM or another party (being
                    interested in buying the Sold Customer Gold). The Platform
                    Provider and/or MUTHOOT EXIM’s responsibilities shall be
                    restricted to ensuring that funds against the Sale of
                    Customer Gold to such Third Party are remitted to Your bank
                    account.
                  </span>
                </p>
                <p className="bold-text">15. STORAGE OF CUSTOMER GOLD</p>
                <p>
                  <span className="om-tnc-ol">
                    15.1. You will be provided with free storage for your
                    Customer Gold for 5 years, or for such period as more
                    particularly stipulated by MUTHOOT EXIM in this regard from
                    time to time at its sole discretion and notified to
                    Customers on the Platform (“Free Storage Period”).
                  </span>
                  <span className="om-tnc-ol">
                    15.2. After the expiry of the Free Storage Period, MUTHOOT
                    EXIM shall be entitled to levy storage charges for such
                    Customer Gold at such rate as would be specified on the
                    Platform, and which may be revised from time to time. The
                    charges would be levied by deducting the eSwarna Digital
                    Gold Balance at the end of each month by a percentage amount
                    at the specified rate. You are advised to periodically check
                    the Platform to understand these storage charges.
                  </span>
                  <span className="om-tnc-ol">
                    15.3. In the event that MUTHOOT EXIM is not able to deduct
                    the storage charges because Your gold balance is too low,
                    then MUTHOOT EXIM shall be entitled to sell such portion of
                    Your Customer Gold stored with the Vault Keeper that is
                    necessary or required to recover the unpaid storage charges
                    in question.
                  </span>
                  <span className="om-tnc-ol">
                    15.4. While reasonable efforts will be made to offer You a
                    competitive price for the Customer Gold, there is no
                    guarantee that the price offered to You will be close to or
                    comparable with other prices available in the market.
                  </span>
                </p>
                <p className="bold-text">16. FRAUDULENT TRANSACTIONS</p>
                <p>
                  <span className="om-tnc-ol">
                    16.1. The Customer should take care not to share their
                    mobile wallet details, personal UPI pin or OTP (“Payment
                    Information”) with any third party intentionally or
                    unintentionally. MUTHOOT EXIM/Platform Provider never
                    solicits Payment Information over a call or otherwise.
                    MUTHOOT EXIM/Platform Provider/Third Party Services/Payment
                    Gateway partners shall not be liable for any fraud due to
                    the sharing of such details.
                  </span>
                  <span className="om-tnc-ol">
                    16.2. In the event that an individual’s Payment Information
                    or Payment Instrument is fraudulently utilised to purchase
                    gold on the Platform (“Fraudulent Transaction”) from MUTHOOT
                    EXIM, then the Platform Provider may share relevant
                    information of such transaction if the victim approaches the
                    Platform Provider via proper channels including MUTHOOT
                    EXIM’s customer support number and email (care@e-swarna.in),
                    along with supporting documentation from the relevant public
                    authority or Cyber Cell.
                  </span>
                  <span className="om-tnc-ol">
                    16.3. In the event that MUTHOOT EXIM and/or the Platform
                    Partner have flagged any transaction or Customer account as
                    suspicious as per their internal guidelines, or where it is
                    found that a Customer has utilised Payment Information or a
                    Payment Instrument in an unauthorised or fraudulent manner
                    to purchase eSwarna Digital Gold or undertake any other
                    transaction on the Platform (Fraudulent User), MUTHOOT EXIM
                    and/or the Platform Partner shall be entitled to:
                  </span>
                  <span className="om-tnc-ol">
                    16.3.1. request further KYC information or other
                    documentation from the User to verify the flagged
                    transaction;
                  </span>
                  <span className="om-tnc-ol">
                    16.3.2. pending further verification, block such Fraudulent
                    User, and/or freeze any accounts associated with them;
                  </span>
                  <span className="om-tnc-ol">
                    16.3.3. reverse any such Fraudulent Transaction, to the
                    extent possible, including the sale of any eSwarna Digital
                    Gold Balance purchased by such Fraudulent User, at the
                    prevailing rate;
                  </span>
                  <span className="om-tnc-ol">
                    16.3.4. provide information on such Fraudulent User, along
                    with any other transaction details, to the relevant
                    authorities.
                  </span>
                  <span className="om-tnc-ol">
                    16.4. In the event of a Fraudulent Transaction as per
                    Section 16.2, MUTHOOT EXIM and/or the Platform Provider,
                    shall make a reasonable effort to assist the Customer or
                    victim in recovering their funds, subject to supporting
                    evidence and documentation being provided upon request. The
                    Platform Provider or MUTHOOT EXIM shall be entitled to
                    transfer the Customer or victim’s funds, less any payment
                    gateway charges that are not refunded by third party payment
                    service provider or bank.
                  </span>
                  <span className="om-tnc-ol">
                    16.5. However, it is clarified that MUTHOOT EXIM and/or the
                    Platform Provider shall not obligated to reverse any
                    transaction where the Fraudulent User has already sold the
                    eSwarna Digital Gold Balance purchased through the
                    Fraudulent Transaction, and received the funds against such
                    sale; or where the Fraudulent User has chosen to take
                    delivery of the eSwarna Digital Gold Balance so purchased.
                    In this event, MUTHOOT EXIM shall, to the best of its
                    ability, provide any information on the Fraudulent User,
                    including the bank account or Mobile Wallet account to which
                    funds have been settled, or the physical address to which
                    the eSwarna Digital Gold Balance has been delivered, to the
                    victim or the relevant authorities.
                  </span>
                </p>
                <p className="bold-text">
                  17. USE OF THE PLATFORM AND SERVICES
                </p>
                <p>
                  <span className="om-tnc-ol">
                    17.1. You acknowledge that the Services are for Your
                    personal use and agree not to publish the eSwarna Digital
                    Gold prices or descriptions of eSwarna Digital Gold and/or
                    any other information displayed on the Platform (in lieu of
                    Your access to the Platform) on any other medium. You shall
                    not modify, copy, distribute, transmit, display, perform,
                    reproduce, publish, license, reverse engineer, create
                    derivative works from, transfer, or sell any information,
                    software, products or services obtained from the Services.
                  </span>
                  <span className="om-tnc-ol">
                    17.2. Subject to these Terms and the Privacy Policy, You
                    hereby grant to MUTHOOT EXIM and the Platform Provider a
                    non-exclusive, worldwide, royalty-free right to (a) collect,
                    store and transmit Your data, in each case solely to the
                    extent necessary to provide the Services to You, and (b)
                    share Your data or interact with other people, to distribute
                    and publicly perform and display Your data as You direct or
                    enable through the Services. You will provide Your consent
                    to the Platform Provider as may be required under applicable
                    law for the use and/or sharing of any data generated by You
                    when purchasing eSwarna Digital Gold or otherwise using the
                    Platform for any services related to the purchasing of
                    eSwarna Digital Gold or for any other purpose as the
                    Platform Provider may stipulate in this regard. The Platform
                    Provider may share Your data with MUTHOOT EXIM, who, in
                    turn, may share Your data with the MUTHOOT EXIM as required
                    to fulfil their obligations as a MUTHOOT EXIM. Your data
                    will continue to be governed by confidentiality obligations
                    outlined in Section 21. It is hereby clarified that MUTHOOT
                    EXIMand the Platform Provider would be the joint owners of
                    any data generated by You when purchasing the Gold on the
                    Platform.
                  </span>
                  <span className="om-tnc-ol">
                    17.3. You represent and warrant that: (i) You have obtained
                    all necessary rights, releases and permissions to provide
                    all Your data to the Platform Provider and MUTHOOT EXIMand
                    to grant the rights granted to the Platform Provider and
                    MUTHOOT EXIM in these Terms and (ii) Your data and its
                    transfer to and use by the Platform Provider and MUTHOOT
                    EXIM as authorized by You under these Terms do not violate
                    any laws or rights of any third party, including without
                    limitation any intellectual property rights, rights of
                    privacy, or rights of publicity, and any use, collection and
                    disclosure authorized herein is not inconsistent with the
                    terms of any applicable privacy policies. Other than its
                    security obligations under these Terms and the Privacy
                    Policy, the Platform Provider and/or MUTHOOT EXIM assume no
                    responsibility or liability for Your data, and You shall be
                    solely responsible for Your data and the consequences of
                    using, disclosing, storing, or transmitting it.
                  </span>
                  <span className="om-tnc-ol">
                    17.4. The Platform Provider and/or MUTHOOT EXIM shall not be
                    held liable for any loss of data, technical or otherwise,
                    information, or for particulars supplied by You, due to the
                    reasons beyond its control like corruption of data or delay
                    or failure to perform as a result of a Force Majeure Event.
                  </span>
                  <span className="om-tnc-ol">
                    17.5. MUTHOOT EXIM shall have the sole discretion to
                    determine the locations and pin codes it may want to serve.
                  </span>
                  <span className="om-tnc-ol">
                    17.6. The provision of Services through the Platform may be
                    interrupted, including for maintenance, repairs, upgrades,
                    or network or equipment failures. The Platform Provider and
                    MUTHOOT EXIM strives to keep the Services up and running;
                    however, all online services suffer occasional disruptions
                    and outages. The Platform Provider and MUTHOOT EXIM are not
                    liable for any disruption or loss You may suffer as a
                    result.
                  </span>
                  <span className="om-tnc-ol">
                    17.7. MUTHOOT EXIM may discontinue some or all of the
                    Services, including certain features and the support for
                    certain devices and platforms, at any time.
                  </span>
                </p>
                <p className="bold-text">
                  18. SUSPENSION / CLOSURE OF eSwarna Digital GOLD ACCOUNT
                </p>
                <p>
                  <span className="om-tnc-ol">
                    18.1. MUTHOOT EXIM and/or Platform Provider may, at its
                    discretion, suspend eSwarna Digital Gold Account of
                    Customers, if there appears to be a fraudulent or suspicious
                    activity in the account. If the Platform Provider and/or
                    MUTHOOT EXIM are of the opinion that You are involved in any
                    unlawful activity or the eSwarna Digital Gold Account is
                    used for any unlawful purpose, the Platform Provider and/or
                    MUTHOOT EXIM shall have the right to take all actions
                    available to it, including black-listing or blocking You
                    from using the Services on the Platform or blocking Your
                    access to the Services through the Platform or intimating
                    the relevant authorities of such unlawful activities.
                  </span>
                  <span className="om-tnc-ol">
                    18.2. Your eSwarna Digital Gold Account may be closed in the
                    event that the arrangement between MUTHOOT EXIM and the
                    Platform Provider is terminated or otherwise the Platform
                    Provider decides to discontinue the relationship with
                    MUTHOOT EXIM. In such an event, Your eSwarna Digital Gold
                    balance may be transferred to the registered bank account
                    and MUTHOOT EXIM may continue to provide the Services and
                    the customer support or facilitate the delivery / sale of
                    Your eSwarna Digital Gold balance.
                  </span>
                  <span className="om-tnc-ol">
                    18.3. Each of the Platform Provider and MUTHOOT EXIM shall
                    not be held liable / responsible, in any manner whatsoever,
                    for any loss / liability arising out of or relating to any
                    technical failure / issue in Platform and / or acts /
                    omission not attributable to it.
                  </span>
                  <span className="om-tnc-ol">
                    18.4. You shall inform immediately, in any case no later
                    than 10 (ten) days of the transaction, of any irregularities
                    or discrepancies that may exist in Your eSwarna Digital Gold
                    Account, failing which it shall be deemed that there is no
                    error or discrepancy in the account. All records maintained
                    by the Platform Provider and/or MUTHOOT EXIM, in electronic
                    or documentary form of the instructions of the Customer and
                    such other details (including, but not limited to payments
                    made or received) pursuant to the Terms, shall as against
                    the Customer, be deemed to be conclusive evidence of such
                    instructions.
                  </span>
                </p>
                <p className="bold-text">19. FEES</p>
                <p>
                  <span className="om-tnc-ol">
                    19.1. You hereby agree that You shall be liable for all fees
                    and charges associated with the use of the Platform and
                    Services, as may applicable. Further, details of the fees
                    payable (including, but not limited to the terms pertaining
                    to such fees and the quantum thereof), have been set out on
                    the Platform. Please note that the fees and charges may be
                    revised from time to time and it would be Your
                    responsibility to view the Platform to check the then
                    current fees and charges payable.
                  </span>
                  <span className="om-tnc-ol">
                    19.2. It is hereby clarified that fees and charges, once
                    paid, are non-refundable.
                  </span>
                  <span className="om-tnc-ol">
                    19.3. All payments made for the use of the Platform and/or
                    purchase of Customer Gold by You shall be compulsorily in
                    Indian Rupees.
                  </span>
                  <span className="om-tnc-ol">
                    19.4. While availing any of the payment method/s available
                    on the Platform for availing the Services, the Platform
                    Provider and MUTHOOT EXIM shall not be responsible for or
                    assume any liability, whatsoever in respect of any loss or
                    damage arising directly or indirectly to You due to:
                  </span>
                  <span className="om-tnc-ol">
                    19.4.1. Lack of authorization for any transaction(s), or
                  </span>
                  <span className="om-tnc-ol">
                    19.4.2. Exceeding the preset limit mutually agreed by You
                    and between bank/s and/or other institutions used by you in
                    making payment, or
                  </span>
                  <span className="om-tnc-ol">
                    19.4.3. Any payment issues arising out of the transaction,
                    or
                  </span>
                  <span className="om-tnc-ol">
                    19.4.4. Rejection of transaction for any other reason(s)
                    whatsoever.
                  </span>
                  <span className="om-tnc-ol">
                    19.5. MUTHOOT EXIM and/or the Platform Provider may
                    temporarily/permanently suspend/terminate the eSwarna
                    Digital Gold Account or refuse access in case of non-payment
                    of fees due by You. Without limitation to the other rights
                    and remedies available to MUTHOOT EXIM and/or the Platform
                    Provider, it also reserves the right to take legal action
                    for the same.
                  </span>
                </p>
                <p className="bold-text">20. MEMBER ELIGIBILITY</p>
                <p>
                  <span className="om-tnc-ol">
                    Use of the Platform and/or the Services is available only to
                    Persons who can enter into legally binding contracts under
                    the Indian Contract Act, 1872 and to Persons resident in
                    India. Persons who are &quot;incompetent to contract&quot;
                    within the meaning of the Indian Contract Act, 1872
                    including minors, un-discharged insolvents and persons of
                    unsound mind are not eligible to use the Platform or the
                    Services. Any person under the age of 18 shall not register
                    on the Platform and shall not transact on or use the
                    Platform in relation to or for any Services. MUTHOOT EXIM
                    reserves the right to terminate any Person’s membership
                    and/or refuse to provide such Person with access to the
                    Platform and/or any Services if it is brought to MUTHOOT
                    EXIM’s notice or if it is discovered that such Person is not
                    eligible to use the Platform and/or any Service.
                  </span>
                </p>
                <p className="bold-text">21. ABSENCE OF RELATIONSHIP</p>
                <p>
                  <span className="om-tnc-ol">
                    21.1. You represent and warrant to the Platform Provider and
                    MUTHOOT EXIM that you have sufficient experience and
                    knowledge to make informed decisions to purchase / sell
                    Gold. You acknowledge that you have not relied on any
                    information made available either by the Platform Provider
                    or MUTHOOT EXIM and that the Platform Provider or MUTHOOT
                    EXIM is not making any recommendation with respect to such
                    purchases / sale-back of Gold. No relationship other than
                    seller-purchaser, including, without limitation, any
                    agent-principal relationship, any advisor-advisee
                    relationship, any employee-employer relationship, any
                    franchisee-franchisor relationship, any joint venture
                    relationship or any partnership relationship, exists between
                    you and the Platform Provider and/or MUTHOOT EXIM.
                  </span>
                  <span className="om-tnc-ol">
                    21.2. You acknowledge that MUTHOOT EXIM and the Platform
                    Provider are not providing / dealing in / offering any
                    investment product and does not offer any guarantee /
                    assured returns. You further acknowledge that value of Gold
                    may vary depending on various factors and forces.
                  </span>
                </p>
                <p className="bold-text">22. ELECTRONIC ORDER RISKS</p>
                <p>
                  <span className="om-tnc-ol">
                    Commercial internet service providers are not 100% reliable
                    and a failure by one or more of these providers may affect
                    internet-based order entry. You acknowledge that the order
                    entry system is an electronic mechanical system and as such
                    may be subject to failure beyond the control of the Platform
                    Provider or MUTHOOT EXIM. Therefore, the Platform Provider
                    or MUTHOOT EXIM shall not be responsible for errors,
                    negligence, inability to execute orders, delays in
                    transmission, delivery or execution of order due to
                    breakdown or failure of transmission or communication
                    facilities (including in any device used to connect to the
                    Platform), or to any other cause beyond Platform Provider’s
                    or MUTHOOT EXIM’s control or anticipation.
                  </span>
                </p>
                <p className="bold-text">23. FEEDBACK</p>
                <p>
                  <span className="om-tnc-ol">
                    23.1. The Platform may allow You, solely at the Platform
                    Provider’s discretion, to post Your review and experience of
                    using the Platform (&quot;Reviews&quot;) in order to improve
                    the Platform and the user experience.
                  </span>
                  <span className="om-tnc-ol">
                    23.2. You hereby grant the Platform Provider and/or MUTHOOT
                    EXIM a perpetual, non-revocable, worldwide, royalty-free and
                    sub-licensable right and license to use, copy, distribute,
                    display, publish, transmit, make available, reproduce,
                    modify, adapt the Reviews in any manner as deemed
                    appropriate by the Platform Provider and/or MUTHOOT EXIM in
                    any form including but not limited to print, broadcast,
                    online and across any and all websites and platforms owned
                    by the Platform Provider.
                  </span>
                  <span className="om-tnc-ol">
                    23.3. You further represent and warrant that while posting
                    any Reviews on the Platform You shall not use any offensive,
                    libellous, derogatory, hateful or racially or ethnically
                    objectionable language. Further, You shall not post any
                    content on any part of the Platform that is obscene,
                    pornographic, constitutes an “indecent representation of
                    women” as provided in the Indecent Representation of Women
                    (Prohibition) Act, 1986.
                  </span>
                </p>
                <p className="bold-text">24. CONFIDENTIALITY</p>
                <p>
                  <span className="om-tnc-ol">
                    As elaborated under the Privacy Policy, the Platform
                    Provider and MUTHOOT EXIM will keep all confidential
                    information confidential, including Your personal
                    information, and shall not disclose it to anyone except with
                    your consent or as required by law, and shall ensure that
                    such confidential information is protected with security
                    measures and a degree of care that it would apply to its own
                    confidential information. The Platform Provider and MUTHOOT
                    EXIM acknowledges that its employees, directors, agents and
                    contractors shall use the confidential information only for
                    the intended purpose for which it is provided. The Platform
                    Provider and MUTHOOT EXIM shall use all reasonable
                    endeavours to ensure that its employees, directors, agents
                    and contractors acknowledge and comply with the provisions
                    of these Terms of confidentiality as if such person was
                    subject to these Terms of confidentiality.
                  </span>
                </p>

                <p className="bold-text">
                  25. CONTENT AND INTELLECTUAL PROPERTY RIGHTS
                </p>
                <p>
                  <span className="om-tnc-ol">
                    25.1. MUTHOOT EXIM solely and exclusively owns its
                    respective copyrights, trademarks, service marks, logos,
                    trade names, and other intellectual and proprietary rights
                    associated with the Services provided by MUTHOOT EXIM and
                    displayed on/accessed on the Platform and is protected under
                    Indian law.
                  </span>
                  <span className="om-tnc-ol">
                    25.2. You hereby acknowledge that the Services constitute
                    original works and have been developed, compiled, prepared,
                    revised, selected, and arranged by MUTHOOT EXIM respectively
                    through the application of methods and standards of judgment
                    developed and applied through the expenditure of substantial
                    time, effort, and money and constitutes valuable
                    intellectual property of MUTHOOT EXIM and such others. You
                    thereby agree to protect the proprietary rights of MUTHOOT
                    EXIM during and after the term of these Terms. You may not
                    selectively download portions of the Platform without
                    retaining the copyright notices. You may download material
                    from the Platform only for the purpose intended by these
                    Terms.
                  </span>
                  <span className="om-tnc-ol">
                    25.3. Any infringement shall lead to appropriate legal
                    proceedings against You at appropriate forum for seeking all
                    available remedies under applicable laws of the country.
                  </span>
                </p>
                <p className="bold-text">
                  26. LINKS TO/FROM THIRD-PARTIES&apos; WEBSITES/APPLICATIONS
                </p>
                <p>
                  <span className="om-tnc-ol">
                    The Platform may contain links and interactive functionality
                    interacting with the websites of third parties. Neither the
                    Platform Provider, nor MUTHOOT EXIM, is responsible for and
                    or has any liability for the functionality, actions,
                    inactions, privacy settings, privacy policies, terms, or
                    content of any such websites. Before enabling any sharing
                    functions to communicate with any such website or otherwise
                    visiting any such website, MUTHOOT EXIM and the Platform
                    Provider strongly recommend that You review and understand
                    the terms and conditions, privacy policies, settings, and
                    information-sharing functions of each such third-party
                    website.
                  </span>
                </p>
                <p className="bold-text">27. INDEMNIFICATION</p>
                <p>
                  <span className="om-tnc-ol">
                    You hereby agree to indemnify and keep the Platform Provider
                    and MUTHOOT EXIM indemnified from and against all actions,
                    claims, demands, proceedings, losses, damages, costs,
                    charges and expenses, directly or indirectly, whatsoever
                    (“Losses”) which the Platform Provider and/or MUTHOOT EXIM
                    and/or its employees, agents, workers or representative may
                    at any time incur, sustain, suffer or be put to as a
                    consequence of or by reason of or arising out of: (i) the
                    usage of the Platform and/or any device used by You to
                    access the Platform; (ii) by reason of the Platform Provider
                    and/or MUTHOOT EXIM acting in good faith and taking or
                    refusing to take or omitting to take action on Your
                    instructions, and in particular arising directly or
                    indirectly out of Your negligence, mistake or misconduct ;
                    (iii) breach or non-compliance of the Terms and relating to
                    the eSwarna Digital Gold Account; and/or (iv) fraud or
                    dishonesty relating to any transaction by You.
                  </span>
                </p>

                <p className="bold-text">28. DISCLAIMER OF WARRANTIES</p>
                <p>
                  <span className="om-tnc-ol">
                    28.1. ALL INFORMATION, CONTENT, MATERIALS AND SERVICES
                    INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
                    PLATFORM (COLLECTIVELY, THE &quot;CONTENTS&quot;) ARE
                    PROVIDED BY MUTHOOT EXIM AND THE PLATFORM PROVIDER ON AN
                    &quot;AS IS,&quot; &quot;AS AVAILABLE&quot; BASIS, WITHOUT
                    REPRESENTATIONS OR WARRANTIES OF ANY KIND. MUTHOOT EXIM
                    AND/OR THE PLATFORM PROVIDER MAKE NO REPRESENTATIONS OR
                    WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
                    OPERATION OF THE PLATFORM, THE ACCURACY OR COMPLETENESS OF
                    THE CONTENTS AND THE ACCURACY OF THE INFORMATION. MUTHOOT
                    EXIM AND/OR THE PLATFORM PROVIDER SHALL HAVE NO
                    RESPONSIBILITY FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR
                    LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY CONTENT,
                    MATERIALS, DOCUMENT OR INFORMATION OR ANY OTHER LOSSES
                    INCURRED BY YOU FOR USE OF THE PLATFORM. YOU EXPRESSLY AGREE
                    THAT THE USE OF THE PLATFORM IS AT YOUR SOLE RISK. MUTHOOT
                    EXIM AND/OR THE PLATFORM PROVIDER WILL NOT BE LIABLE FOR ANY
                    DAMAGES OF ANY KIND ARISING FROM THE USE OF THE PLATFORM OR
                    THE SERVICES OR THE CONTENTS INCLUDING, WITHOUT LIMITATION,
                    DIRECT, INDIRECT, PUNITIVE, AND CONSEQUENTIAL DAMAGES,
                    UNLESS OTHERWISE SPECIFIED IN WRITING. TO THE FULL EXTENT
                    PERMITTED BY LAW, MUTHOOT EXIM AND/OR THE PLATFORM PROVIDER
                    DISCLAIMS ANY AND ALL REPRESENTATIONS AND WARRANTIES WITH
                    RESPECT TO THE PLATFORM (OR ANY PART THEREOF) AND ITS
                    CONTENTS, WHETHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT
                    LIMITATION, WARRANTIES OF TITLE, MERCHANTABILITY, AND
                    FITNESS FOR A PARTICULAR PURPOSE OR USE.
                  </span>
                </p>

                <p className="bold-text">29. LIMITATION OF LIABILITY</p>
                <p>
                  <span className="om-tnc-ol">
                    You hereby acknowledge that MUTHOOT EXIM and/or the Platform
                    Provider (including but not limited to its, directors,
                    employees, agents or partners) shall not be held liable to
                    You for any special, consequential, incidental, and
                    exemplary or punitive damages, or loss of profit or
                    revenues. MUTHOOT EXIM and/or the Platform Provider shall
                    also not be liable under any circumstances for damages
                    arising out or related in any way to Your inability to
                    access, or Your difficulty in accessing the Platform to
                    avail of any Services, any bugs, viruses, trojan horses, or
                    the like, which may be transmitted to or through the
                    Platform by any third party, any loss of Your data, any
                    claim relating to Your data or content from the Services
                    and/or Your failure to keep the eSwarna Digital Gold Account
                    Information secure and confidential. You further agree that
                    MUTHOOT EXIM shall not be held responsible in any manner
                    whatsoever for any and all acts or omissions of the Platform
                    Provider, any Intermediaries or any other third party
                    whosoever including (but not limited to) any person whose
                    device has been used by You to access the Platform and/or
                    any person appointed/nominated by the Platform Provider for
                    the purposes of accepting/collecting any payments from You
                    for the purchase of Gold. Likewise, the Platform Provider
                    shall not be held responsible in any manner whatsoever for
                    any and all acts of any third party, MUTHOOT EXIM or other
                    Intermediaries.
                  </span>
                </p>
                <p className="bold-text">30. GRIEVANCE REDRESSAL MECHANISM</p>
                <p>
                  <span className="om-tnc-ol">
                    30.1. In accordance with the Information Technology Act,
                    2000 and Rules made thereunder:
                  </span>
                  <span className="om-tnc-ol">
                    30.1.1. the contact details of Grievance Officer for the
                    purposes of the Platform Provider are:
                  </span>
                  <span className="om-tnc-ol">Name: Ms. Julia Mathew</span>
                  <span className="om-tnc-ol">
                    E-mail ID:{' '}
                    <a href="mailto:julia.mathew@muthoot.com">
                      julia.mathew@muthoot.com
                    </a>
                  </span>
                  <span className="om-tnc-ol">
                    Contact: <a href="tel:0471-4911626">0471-4911626</a>
                  </span>
                  <span className="om-tnc-ol om-tnc-imp-text-info">
                    *Contact between 09:00 am to 06:00 pm (Monday to Saturday
                    except on National Holidays)
                  </span>
                  <span className="om-tnc-ol">
                    30.1.2. the contact details of Grievance Officer for the
                    purposes of MUTHOOT EXIM are:
                  </span>

                  <span className="om-tnc-ol">
                    Registered Office: MUTHOOT EXIM PRIVATE LIMITED 40/7384
                    Muthoot Towers, M.G. Road, Ernakulum, Kerala- 682035
                  </span>
                  <span className="om-tnc-ol">
                    Corporate Office: MUTHOOT EXIM PRIVATE LIMITED 18th Floor,
                    Sunshine Tower, Senapati Bapat Marg, Dadar (W), Next to
                    India Bulls Finance Centre (Parel) Mumbai – 400013
                  </span>
                  <span className="om-tnc-ol">
                    E-mail ID:{' '}
                    <a href="mailto:eswarna@muthootexim.com">
                      eswarna@muthootexim.com
                    </a>
                  </span>
                  <span className="om-tnc-ol">
                    Contact: Tollfree no.{' '}
                    <a href="tel:1800 102 1616">1800 102 1616</a>
                  </span>
                  <span className="om-tnc-ol">Fax: 0484 2351494</span>
                </p>

                <p className="bold-text">31. AMENDMENTS, ACCEPTANCE OF TERMS</p>
                <p>
                  <span className="om-tnc-ol">
                    31.1. MUTHOOT EXIM reserves the right, to change, modify,
                    add or remove portions of these Terms at any time. Such
                    changes shall be posted on the Platform and shall be
                    notified to the Customer prior to making such changes.
                    Notwithstanding anything to the contrary, Customer shall be
                    responsible for regularly reviewing the Terms, including
                    amendments thereto as may be posted on the Platform and
                    shall be deemed to have accepted the amended Terms by
                    continuing the use of Platform.
                  </span>
                  <span className="om-tnc-ol">
                    31.2. Accessing, browsing or otherwise using the Platform
                    indicates Your agreement to all the terms and conditions
                    under these Terms. You are advised to read these Terms
                    carefully before proceeding. By impliedly or expressly
                    accepting these Terms, You also accept and agree to be bound
                    by all policies, including but not limited to the privacy
                    policy of the Platform Provider and MUTHOOT EXIM (“Privacy
                    Policy”), as amended from time to time. You can view and
                    read the Privacy Policy of the Platform Provider at the
                    Platform and the Privacy Policy of MUTHOOT EXIM at{' '}
                    <a href="https://www.muthootexim.com/">
                      https://www.muthootexim.com/
                    </a>
                  </span>
                  <span className="om-tnc-ol">
                    31.3. You may not use the Platform or avail of the Services
                    if You do not accept the Terms or are unable to be bound by
                    the Terms. As a condition of Your access to and use of the
                    Platform or the provision of any Services to You using the
                    Platform, You agree that You will comply with all applicable
                    laws and regulations when using the Platform. If MUTHOOT
                    EXIM is of the opinion that the eSwarna Digital Gold Account
                    is being used by You for any unlawful purpose, MUTHOOT EXIM
                    shall have the right to take all actions available to it,
                    including black-listing or blocking You from using the
                    Services through the Platform or intimating the relevant
                    authorities of such unlawful activities.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default TermsandConditions;
